module.exports = __webpack_public_path__ + "static/forbes.5f6b4c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/forbes.png
// module id = 479
// module chunks = 35783957827783